import { useRouter } from 'vue-router';

import { useCustomerFeaturesStore } from '@/stores/customerFeatures';
import { useUserStore } from '@/stores/user';
import { isSafeRedirect } from '@/utils/safeRedirect';

/**
 * Continues once a Google or Microsoft sign-in signed the session in, exactly as after a password sign-in: an
 * unfinished registration resumes in the wizard, anything else goes to the path it was headed for.
 */
export function useSignedInLanding() {
  const router = useRouter();
  const userStore = useUserStore();
  const featureStore = useCustomerFeaturesStore();

  return async function land(returnPath: string | null) {
    await userStore.fetchCurrent();

    if (userStore.hasUnfinishedRegistration) {
      router.replace(userStore.authenticatedLandingRoute());
      return;
    }

    await featureStore.fetchFeatures();
    router.replace(isSafeRedirect(returnPath) ? returnPath : { name: 'home' });
  };
}
